// extracted by mini-css-extract-plugin
export default {"mainLoader":"MainLoader_mainLoader__fhCEk"};